import { Component, OnInit, ViewChild, ElementRef,Renderer2 } from '@angular/core';
import { ApiService } from '../services/api.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/Rx';
import { Subject } from 'rxjs/Rx';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  result:any = [];
  loading;
  empty;
  postQuestion;
  questionSearch;
  voted=[];
  alertPost:boolean=false;
  @ViewChild('alert', { static: true }) alert: ElementRef;
  constructor(private api: ApiService, private route: ActivatedRoute, private router: Router, private elem: ElementRef) {
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
     if(data.kind=='post')
     this.postQuestion=true;
     else if(data.kind=='posted'){
          this.alert.nativeElement.classList.add('show');
          this.postQuestion=false;
     }
     else
     this.postQuestion=false;
    });
    this.loading=false;
    this.empty=false;

  }

  searchQuestion(f){
    this.loading=true;
    this.api.getPosts(f.value.question).subscribe((data:any)=>{
      this.result = data;
      this.loading=false;
      // this.result=[];
      this.voted=[];
      for(var i=0;i<this.result.length;i++){
        this.result[i].dateFromNow=moment(this.result[i].date).fromNow();
        // this.result[i].upvoted=false;
        // this.result[i].downvoted=false;
        this.voted.push(false);
      }
      // console.log(this.result);
      if(this.result.length==0)
          this.empty=true;
        else
          this.empty=false;
    });

  }
  postQA(f2){
    this.api.addPost({"question" : f2.value.postQuestion, "answer":f2.value.postAnswer}).subscribe(data=>{
      this.postQuestion=false;
      this.alertPost=true;
      this.router.navigate(['posted']);
      // this.alert.nativeElement.classList.add('show');
      // console.log(this.alertPost)
    });

  }

  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }
  upvote(index,color){
    if(this.voted[index]) return;
    // console.log(this.result);
    // console.log(this.result[index].upvoted);
    // if(this.result[index].upvoted) {
    //   console.log(index);
    //   return this.downvote(index,"grey");
    // }
    // this.result[index].upvoted=true;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[0].style="color:"+color;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[3].style="color:"+color;
    if(color=="black") this.result[index].upvoted=false;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[2].style="color:grey";
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[1].innerHTML=parseInt(this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[1].innerHTML)+1;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[4].innerHTML=parseInt(this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[4].innerHTML)+1;
    this.api.upvote(this.result[index]._id).subscribe(data=>{
      // console.log(data);
    });
    this.voted[index]=true;
  }
  downvote(index,color){
    if(this.voted[index]) return;
    // if(this.result[index].downvoted){
      // return this.upvote(this.result[index]._id,"grey");
    // }
    // this.result[index].downvoted=true;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[0].style="color:grey;";
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[2].style="color:"+color;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[5].style="color:"+color;
    if(color=="black") this.result[index].downvoted=false;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[1].innerHTML=parseInt(this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[1].innerHTML)-1;
    this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[4].innerHTML=parseInt(this.elem.nativeElement.getElementsByClassName(this.result[index]._id)[4].innerHTML)-1;
    this.api.downvote(this.result[index]._id).subscribe(data=>{
      // console.log(data);
    });
    this.voted[index]=true;
  }
}
